<mat-card class="p-4">
  <mat-card-title class="flex w-full justify-between mx-2 items-center mb-2">
    <div class="flex w-full justify-between items-center">
      <span class="text-gray-700 font-bold">Importar Planilha de Passageiros</span>
      <button class="btn-icon" matSuffix (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-title>
  <mat-divider class="my-2" />

  @if (!importResult) {
    <div [formGroup]="form" class="mt-4 w-full flex flex-col">
      <div class="flex justify-center mt-2 gap-5 items-center w-full">
        <div class="mt-message-input w-8/12 p-2">
          <input
            hidden
            type="file"
            accept=".xlsx"
            (change)="onFileSelected($event)"
            #fileInput
          />
          <mat-form-field
            class="input-tg w-full"
            appearance="outline"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
          >
            <mat-label>Arquivo (.xlsx)</mat-label>
            <input matInput formControlName="file" (click)="fileInput.click()" readonly />
            <button mat-icon-button matSuffix type="button" (click)="fileInput.click()">
              <mat-icon>upload</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="flex justify-center items-center gap-4 p-2">
          <button mat-flat-button class="btn-tg" (click)="cancel()">Cancelar</button>
          <button mat-flat-button class="btn-tg" [disabled]="form.invalid || loading" (click)="createFile()">
            @if (loading) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Importar
            }
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="mt-4 px-2">
      <div class="text-gray-600 text-sm mb-4">Importação concluída com sucesso.</div>
      <div class="grid grid-cols-2 gap-3 mb-6">
        <div class="rounded-lg border border-green-200 bg-green-50 p-3 flex flex-col items-center">
          <span class="text-2xl font-bold text-green-600">{{ importResult.totalCompletos }}</span>
          <span class="text-xs text-gray-500 mt-1">Completos</span>
        </div>
        <div class="rounded-lg border border-yellow-200 bg-yellow-50 p-3 flex flex-col items-center">
          <span class="text-2xl font-bold text-yellow-600">{{ importResult.totalIncompletos }}</span>
          <span class="text-xs text-gray-500 mt-1">Incompletos</span>
        </div>
        <div class="rounded-lg border border-red-200 bg-red-50 p-3 flex flex-col items-center">
          <span class="text-2xl font-bold text-red-500">{{ importResult.totalIgnorados }}</span>
          <span class="text-xs text-gray-500 mt-1">Ignorados</span>
        </div>
        <div class="rounded-lg border border-blue-200 bg-blue-50 p-3 flex flex-col items-center">
          <span class="text-2xl font-bold text-blue-600">{{ importResult.totalPessoasUnicas }}</span>
          <span class="text-xs text-gray-500 mt-1">Pessoas únicas</span>
        </div>
      </div>
      <div class="text-xs text-gray-400 mb-4">
        Total de trechos importados: <strong>{{ importResult.totalTrechos }}</strong>
      </div>
      <div class="flex justify-end">
        <button mat-flat-button class="btn-tg" (click)="closeModal()">Fechar</button>
      </div>
    </div>
  }
</mat-card>
